import { useEffect } from "react";
import { ws } from "api/webSocket";
import {
  authenticate,
  resetState,
  updateState,
  useGame,
} from "context/GameContext";
import { useHistory } from "react-router";

export const useApp = () => {
  const [{ player }, gameDispatch] = useGame();
  const history = useHistory();

  useEffect(() => {
    ws.watchAuthentication((e) => {
      authenticate(gameDispatch, e);
    });

    ws.watchWaitingRoom((e) => {
      updateState(gameDispatch, e, player?.id);
      if (window.location.pathname !== "/game/waiting-room")
        history.push("/game/waiting-room");
    });

    ws.watchBoard((e) => {
      updateState(gameDispatch, e, player?.id);
      if (window.location.pathname !== "/game/board")
        history.push("/game/board");
    });

    ws.watchEnd((e) => {
      resetState(gameDispatch);
      if (window.location.pathname !== "/home")
        window.location.pathname = "/home";
    });
  }, [gameDispatch, history, player]);
};
